'use strict';

var resolvers = {
  user: {
    user: user
  }
};

function user($route) {
  return $route.current.params.user;
}

module.exports = resolvers;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/admin/resolve/index.js
 ** module id = 321
 ** module chunks = 0
 **/